import axios, { AxiosPromise } from "axios";
import Logger from "../Logger/Logger";
import Url from "../Url/Url";
import ResponseNormalizer, { NormalizedErrorResponseInterface } from "./ResponseNormalizer";
import RequestNormalizer from "./RequestNormalizer";
import Store from "../Store/Store";
// import Token from "../Token/Token";
// import Auth from "../Auth/Auth";
import Environment from "../Environment/Environment";

class Http {
  public setBearer(token): Promise<string> {
    return new Promise(accept => {
      axios.defaults.headers.common.Authorization = `Bearer ${token}`;
      console.log(token, "token")
      return accept(token);
    });
  }

  public get(path: string, params: any = {}, toBackend: boolean = true): AxiosPromise {
    const method: string = "GET";

    return axios({
      url: Url.to(path, toBackend),
      method: method,
      responseType: "json",
      data: RequestNormalizer.normalize(params)
    })
    .then(res => {
      if (Environment.isDevelopment()) {
        Logger.log(`${method} ${path}`);
        Logger.debug(res);
      }
      
      // if (res.headers.token) {
      //   return Auth.getSession(res.headers.token);
      // }

      return res;
    })
    .catch(err => {
      const normalizedError: NormalizedErrorResponseInterface = ResponseNormalizer.normalize(err);
      return Promise.reject(normalizedError);
    });
  }

  public post(path: string, params: any = {}): AxiosPromise {
    const method: string = "POST";

    return axios({
      url: Url.to(path),
      method: method,
      responseType: "json",
      data: RequestNormalizer.normalize(params)
    })
    .then(res => {
      Logger.log(`${Store.getConfigurator().getState().app?.session?.user?.displayName || "unknown user"} is doing: ${method} ${path}`, true, RequestNormalizer.normalize(params));
      
      if (Environment.isDevelopment()) {
        Logger.log(`${method} ${path}`);
        Logger.debug(res);
      }

      return res;
    })
    .catch(err => {
      const normalizedError: NormalizedErrorResponseInterface = ResponseNormalizer.normalize(err);
      return Promise.reject(normalizedError);
    });
  }

  public delete(path: string, params: any = {}): AxiosPromise {
    const method: string = "DELETE";

    return axios({
      url: Url.to(path),
      method: method,
      responseType: "json",
      data: RequestNormalizer.normalize(params)
    })
    .then(res => {
      Logger.log(`${Store.getConfigurator().getState().app?.session?.user?.displayName || "unknown user"} is doing: ${method} ${path}`, true, RequestNormalizer.normalize(params));

      if (Environment.isDevelopment()) {
        Logger.log(`${method} ${path}`);
        Logger.debug(res);
      }

      return res;
    })
    .catch(err => {
      const normalizedError: NormalizedErrorResponseInterface = ResponseNormalizer.normalize(err);
      return Promise.reject(normalizedError);
    });
  }

  public put(path: string, params: any = {}): AxiosPromise {
    const method: string = "PUT";

    return axios({
      url: Url.to(path),
      method: method,
      responseType: "json",
      data: RequestNormalizer.normalize(params)
    })
    .then(res => {
      Logger.log(`${Store.getConfigurator().getState().app?.session?.user?.displayName || "unknown user"} is doing: ${method} ${path}`, true, RequestNormalizer.normalize(params));

      if (Environment.isDevelopment()) {
        Logger.log(`${method} ${path}`);
        Logger.debug(res);
      }

      return res;
    })
    .catch(err => {
      const normalizedError: NormalizedErrorResponseInterface = ResponseNormalizer.normalize(err);
      return Promise.reject(normalizedError);
    });
  }

  public patch(path: string, params: any = {}): AxiosPromise {
    const method: string = "PATCH";

    return axios({
      url: Url.to(path),
      method: method,
      responseType: "json",
      data: RequestNormalizer.normalize(params)
    })
    .then(res => {
      Logger.log(`${Store.getConfigurator().getState().app?.session?.user?.displayName || "unknown user"} is doing: ${method} ${path}`, true, RequestNormalizer.normalize(params));

      if (Environment.isDevelopment()) {
        Logger.log(`${method} ${path}`);
        Logger.debug(res);
      }

      return res;
    })
    .catch(err => {
      const normalizedError: NormalizedErrorResponseInterface = ResponseNormalizer.normalize(err);
      return Promise.reject(normalizedError);
    });
  }
}

export default new Http();
